import { Card, Col, Form, InputGroup, Row } from 'react-bootstrap';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import './SendMessage.scss';
import MultipleFileUpload from 'src/Components/fileupload/MultipleFileUpload';
import { Formik } from 'formik';
import useMyMessage from '../hook/useMyMessage';
import { Fragment } from 'react';
import FileInfo from 'src/Components/fileupload/FileInfo';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import TextInput from 'src/Components/GenericInputText/TextInput';

const SendMessage = ({
  isComposing,
  setIsComposing,
  setReplyEnabled,
  setIsComposed,
}) => {
  const {
    schema,
    replyMessageSchema,
    submitComposeMessage,
    submitReplyMessage,
    files,
    setFiles,
    subject,
    docType,
    setDocType,
    typeOptionList,
    comments,
    referenceNumber,
    formRef,
    setComments,
  } = useMyMessage({ setIsComposed });
  return (
    <div className="send-message-wrapper">
      <Formik
        validationSchema={isComposing ? schema : replyMessageSchema}
        initialValues={
          isComposing
            ? {
                subject: subject,
                type: docType,
                refreance: referenceNumber,
                file: files,
                comments: comments,
              }
            : {
                subject: subject,
                type: docType,
                file: files,
                comments: comments,
              }
        }
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldTouched,
          setFieldValue,
          values,
          touched,
          errors,
        }) => (
          <Form
            className="compose-message-container"
            onSubmit={(e) => {
              handleSubmit(e);
              console.log('errors :', errors);
              if (
                Object.keys(errors).length === 0 &&
                isComposing &&
                values?.subject &&
                values?.type &&
                values?.comments
              ) {
                submitComposeMessage(values);
              } else if (
                Object.keys(errors).length === 0 &&
                isComposing === false
              ) {
                submitReplyMessage(values);
              }
            }}
            ref={formRef}
          >
            {isComposing && (
              <Card>
                <div className="d-flex justify-content-between align-items-center p-3 rounded-3">
                  <div className="message_title">Compose a message</div>
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="mr-3 cursor-pointer"
                      onClick={() => {
                        setIsComposing(false);
                      }}
                    >
                      Cancel
                    </div>
                    <div>
                      <GenericButton type="submit" variant="primary">
                        SEND
                      </GenericButton>
                    </div>
                  </div>
                </div>
              </Card>
            )}
            <div>
              <Card className="mt-3 p-3">
                <div>
                  {isComposing && (
                    <>
                      <Row>
                        <Col>
                          <Form.Group controlId="subject">
                            <Form.Label className="message-labels">
                              Subject
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="subject"
                              placeholder="Example:Claim Submission "
                              className=""
                              value={values.subject ?? ''}
                              spellCheck="off"
                              autoCorrect="off"
                              autoComplete="off"
                              autoFocus={false}
                              onChange={(e) => {
                                setFieldTouched('subject');
                                handleChange(e);
                              }}
                              isInvalid={touched.subject && errors.subject}
                              aria-required={true}
                              aria-invalid={errors.subject ? true : null}
                              aria-describedby="err_subject"
                            />
                            <Form.Control.Feedback
                              type="invalid"
                              className="d-flex p-0"
                              aria-live="polite"
                              id="err_subject"
                              role="alert"
                            >
                              <span>{touched.subject && errors.subject}</span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="pr-2">
                          <Form.Group controlId="type" className="mb-0">
                            <Form.Label className="message-labels">
                              Type
                            </Form.Label>
                            <AutoSuggestionSelectComponent
                              options={typeOptionList?.filter(
                                (item) => item?.Categorycode !== 'Published',
                              )}
                              name="type"
                              components={{ IndicatorSeparator: () => null }}
                              value={docType}
                              onChange={(e) => {
                                const event = {
                                  target: { name: 'type', value: e },
                                };
                                setDocType(e);
                                handleChange(event);
                              }}
                              onBlur={() => {
                                handleBlur({ target: { name: 'type' } });
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.type && errors.type
                                  ? 'invalid-error'
                                  : ''
                              }
                              labelText={'filter dropdown, type'}
                              isInvalid={touched.type && errors.type}
                              valid={errors.type ? true : null}
                              describedby="err_type"
                            />
                            <span
                              type="invalid"
                              className="d-flex p-0 invalid-feedback"
                              aria-live="polite"
                              id="err_type"
                              role="alert"
                            >
                              {touched.type && errors.type}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col>
                          {docType?.MappedEntity === 'CLAIM' && (
                            <Form.Group controlId="refreance">
                              <Form.Label className="message-labels">
                                Claim Number
                              </Form.Label>
                              <TextInput
                                name="refreance"
                                parentClassName="refrence-input"
                                append={
                                  <InputGroup.Text className="bg-transparent">
                                    <SearchSVG.SearchSVG />
                                  </InputGroup.Text>
                                }
                                inputProps={{
                                  type: 'text',
                                  name: 'refreance',
                                  placeholder: 'Example: CLM20230620001 ',
                                  className: 'claim-number-input',
                                  value: values.refreance ?? '',
                                  onChange: (e) => {
                                    handleChange(e);
                                  },
                                  'aria-required': true,
                                  'aria-invalid': errors.refreance
                                    ? true
                                    : null,
                                  'aria-describedby': 'err_refreance',
                                }}
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="d-flex p-0"
                                aria-live="polite"
                                id="err_refreance"
                                role="alert"
                              >
                                <span>
                                  {touched.refreance && errors.refreance}
                                </span>
                              </Form.Control.Feedback>
                            </Form.Group>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row className="w-90 mt-3">
                    <Col md={12} lg={12} sm={12}>
                      <MultipleFileUpload
                        className={
                          files.length <= 0 && touched.file && errors.file
                            ? 'errorbackground'
                            : ''
                        }
                        files={files}
                        setFiles={setFiles}
                        name="file"
                        setFieldValue={setFieldValue}
                      />
                      {files && files.length > 0 ? (
                        ''
                      ) : (
                        <span className="sr-only">
                          {touched.file && errors.file}
                        </span>
                      )}
                    </Col>
                    <Col lg={7}>
                      {files.length > 0 ? (
                        <div
                          className="sr-only"
                          role="heading"
                          aria-level={1}
                          tabIndex={0}
                        >
                          {`${files.length} file${
                            files.length > 1 ? 's' : ''
                          } selected to upload `}
                        </div>
                      ) : (
                        ''
                      )}
                      <div>
                        {files &&
                          files.map((item, index) => {
                            return (
                              <Fragment key={index}>
                                <FileInfo
                                  files={files}
                                  setFiles={setFiles}
                                  fileDetails={item}
                                  filesLoader={false}
                                  setFieldValue={setFieldValue}
                                  readFileSize={true}
                                />
                              </Fragment>
                            );
                          })}
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3 w-90">
                    <Col md={12} lg={12} sm={12}>
                      <Form.Group className="form-block" controlId="comments">
                        <Form.Control
                          rows={10}
                          as="textarea"
                          className="comments"
                          spellCheck="off"
                          autoCorrect="off"
                          autoComplete="off"
                          name="comments"
                          autoFocus={false}
                          onBlur={(e) => {
                            handleBlur(e);
                            const storeComments = e.currentTarget.value.trim();
                            setFieldValue('comments', storeComments);
                          }}
                          onChange={(e) => {
                            setFieldTouched('comments');
                            handleChange(e);
                            setComments(e.target.value);
                          }}
                          value={values?.comments ?? ''}
                          isInvalid={touched.comments && errors.comments}
                          aria-required={true}
                          aria-invalid={errors.comments ? true : null}
                          aria-describedby="err_comments"
                        />
                        <span
                          type="invalid"
                          className="d-flex p-0 invalid-feedback"
                          aria-live="polite"
                          id="err_comments"
                          role="alert"
                        >
                          {touched.comments && errors.comments}
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  {!isComposing && (
                    <div className="d-flex align-items-center justify-content-end gap-3">
                      <div
                        className="mr-3 cursor-pointer"
                        onClick={() => {
                          setReplyEnabled(false);
                        }}
                      >
                        Cancel
                      </div>
                      <div>
                        <GenericButton type="submit" variant="primary">
                          REPLY
                        </GenericButton>
                      </div>
                    </div>
                  )}
                </div>
              </Card>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SendMessage;
